import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  // Checkbox,
  // FormControlLabel,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import DateRangeSelector from "../../../../Components/FormComponents/DateRangeSelector";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import withAuth from "../../../../Hoc/withAuth";
import MainAppContainer from "../../../../Components/Containers/MainAppContainer";
import PageHeader from "../../../../Components/Bits/PageHeader";
import axios from "axios";
import QAFailedSales from "./Components/QAFailedSales";

const ExtractsMain = ({ user }) => {
  const { token } = user;
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedClient, setSelectedClient] = useState("");

  const handleClientChange = (event) => {
    setSelectedClient(event.target.value);
  };

  // get all clients from axios endpoint `${process.env.REACT_APP_API_URL}/callCentre/clients`
  useEffect(() => {
    const fetchClients = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/callCentre/clients`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        // filter out clients with active = false
        const filteredClients = response.data.data.filter(
          (client) => client.active,
        );
        // sort clients by name
        filteredClients.sort((a, b) => a.name.localeCompare(b.name));

        setClients(filteredClients);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, [token]);

  const { pathname } = useLocation();
  const [value, setValue] = useState([
    dayjs().startOf("month"),
    dayjs().endOf("month"),
  ]);
  // const [downloadExcel, setDownloadExcel] = React.useState(false);
  const [selectedPath, setSelectedPath] = useState(
    pathname.split("/")[3] || "",
  );
  const [reportTrigger, setReportTrigger] = useState(false);
  const [startDate, setStartDate] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    dayjs().endOf("month").format("YYYY-MM-DD"),
  );
  const [accordionExpanded, setAccordionExpanded] = useState(true);
  const [reportName, setReportName] = useState("");

  dayjs.extend(utc);
  dayjs.extend(timezone);

  const Paths = [
    {
      name: "QA Failed Sales",
      location: "QAFailedSales",
    },
  ];

  const handleChange = (event) => {
    const newPath = event.target.value;
    setSelectedPath(newPath);
    setReportName(Paths.find((path) => path.location === newPath)?.name || "");
    // navigate(newPath);
  };

  // const handleExcelChange = (event) => {
  //   setDownloadExcel(event.target.checked);
  // };

  const handleRunReport = () => {
    // Format dates consistently
    const formattedStartDate = value[0].format("YYYY-MM-DD");
    const formattedEndDate = value[1].format("YYYY-MM-DD");

    // Collapse accordion
    setAccordionExpanded(false);

    // Handle detailed campaign separately since it's not using Outlet
    if (["QAFailedSales"].includes(selectedPath)) {
      setStartDate(formattedStartDate);
      setEndDate(formattedEndDate);
      setReportTrigger(true);
      setReportName(
        Paths.find((path) => path.location === selectedPath)?.name || "",
      );
    }

    console.log("Running report with:", {
      dateRange: {
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      },
      selectedClient,
      currentPath: selectedPath,
    });
  };

  const reportComponents = { QAFailedSales };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error...</div>;

  if (clients.length === 0) return <div>No clients available</div>;

  // console.log("clients", clients);

  return (
    <MainAppContainer>
      <PageHeader
        title="Extracts"
        subheader="Various"
        breadcrumbs={[
          {
            title: "Dashboard",
            href: "/",
          },
          {
            title: "Extracts",
            href: "/extracts",
          },
        ]}
      />

      <Box sx={{ mt: 4 }}>
        <Accordion
          expanded={accordionExpanded}
          onChange={() => setAccordionExpanded(!accordionExpanded)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="report-settings-content"
            id="report-settings-header"
          >
            <Typography variant="h6">Extract Settings</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <FormControl fullWidth>
                <InputLabel>Select Extract</InputLabel>
                <Select
                  value={selectedPath}
                  onChange={handleChange}
                  label="Select Extract"
                >
                  {Paths.map((path, index) => (
                    <MenuItem key={index} value={path.location}>
                      {path.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel>Select Client</InputLabel>
                <Select
                  value={selectedClient}
                  onChange={handleClientChange}
                  label="Select Client"
                >
                  {clients.map((client, index) => (
                    <MenuItem key={index} value={client.id}>
                      {client.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ mt: 4 }}>
              <DateRangeSelector value={value} setValue={setValue} />
            </Box>
            <Box sx={{ mt: 4, display: "flex", alignItems: "center", gap: 2 }}>
              {/* <FormControlLabel
                control={
                  <Checkbox
                    checked={downloadExcel}
                    onChange={handleExcelChange}
                    color="primary"
                    disabled={true}
                  />
                }
                label="Download to Excel"
              /> */}
              {
                // select the client from the clients array
              }

              <Button
                variant="contained"
                color="primary"
                onClick={handleRunReport}
              >
                Run Extract
              </Button>
            </Box>
          </AccordionDetails>
        </Accordion>

        {
          // run report based on selectedPath
          reportTrigger && (
            <>
              <div>
                <h2>Extract: {reportName} </h2>
                <h3>
                  Client:{" "}
                  {clients.find((client) => client.id === selectedClient)?.name}
                </h3>
                <p>
                  {startDate} to {endDate}
                </p>

                {reportComponents[selectedPath] ? (
                  React.createElement(reportComponents[selectedPath], {
                    startDate,
                    endDate,
                    client: selectedClient,
                    token,
                  })
                ) : (
                  <Outlet context={{ value, selectedPath }} />
                )}
              </div>
            </>
          )
        }
      </Box>
    </MainAppContainer>
  );
};

export default withAuth(ExtractsMain);
